"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = UploadFileButton;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../libs/utils");

var _uploadFileLabel = _interopRequireDefault(require("./styled/uploadFileLabel"));

var _uploadIcon = _interopRequireDefault(require("./styled/uploadIcon"));

var _hiddenElement = _interopRequireDefault(require("../../Structural/hiddenElement"));

function UploadFileButton(_ref) {
  var onChange = _ref.onChange,
      isDragOver = _ref.isDragOver;

  var _useState = (0, _react.useState)((0, _utils.uniqueId)('upload-file-input')),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
      uploadFileInputId = _useState2[0];

  return /*#__PURE__*/_react["default"].createElement(_uploadFileLabel["default"], {
    htmlFor: uploadFileInputId,
    isDragOver: isDragOver
  }, /*#__PURE__*/_react["default"].createElement(_hiddenElement["default"], {
    as: "input",
    id: uploadFileInputId,
    type: "file",
    accept: "text/csv",
    multiple: false,
    onChange: onChange
  }), /*#__PURE__*/_react["default"].createElement(_uploadIcon["default"], null), "Upload CSV File");
}

UploadFileButton.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  isDragOver: _propTypes["default"].bool
};
UploadFileButton.defaultProps = {
  isDragOver: false
};